export default "__VITE_ASSET__CkrW1pMh__"